export const tenantIndexHeaders = [
  {
    text: "Created At",
    value: "created_at"
  },
  {
    text: "Employee",
    value: "employee"
  },
  {
    text: "Note",
    value: "note"
  }
];
